/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { FormControl, FormControlLabel, Switch } from '@mui/material';
import { CustomStack } from 'modules/common/components';
import styles from 'modules/transactions/components/inner-filter/inner-filter.module.scss';
/**
 * De-aggregated switch component common for the transaction component
 * @param {Boolean} value - Toggle value
 * @param {Function} onChange - Function to call when the toggle value changes
 * @returns
 */
const DeAggregateToggle = ({ value, onChange }) => (
  <CustomStack cssClassName={styles.innerFilter}>
    <FormControl sx={{ paddingTop: 3, paddingBottom: 3 }}>
      <FormControlLabel
        control={<Switch checked={value} onChange={onChange} />}
        label="De-aggregated"
        sx={{
          width: 'fit-content',
          height: 10,
        }}
      />
    </FormControl>
  </CustomStack>
);
//
export default DeAggregateToggle;
